import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    REMOVE_FAILED_USER_QUIZ: (userId) => ({ userId }),
    API: {
      REMOVE_FAILED_USER_QUIZ: apiResourceActionCreator('userQuiz')
    }
  }
})

export const apiAction = (authToken, userId) => commonApiActions.authenticated.get(`${API_ENDPOINT}/removeFailedQuiz/${userId}`, authToken, action.admin.api.removeFailedUserQuiz)

function* removeFailedUserQuiz(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.userId));
}

const configuration = {
  name: 'removeFailedUserQuiz',
  action: action,
  sagas: removeFailedUserQuiz,
  reducers: {
    request: (state, action) => ({
      ...state,
      isRemovingUserQuiz: true
    }),
    success: (state, action) => {
      return ({
        ...state,
        userData: {
          ...state.userData,
          result: fp.map(
            (userProfile) => ({
              ...userProfile,
              cpdPoints: action.payload.userQuiz === userProfile.user.id ? [] : userProfile.cpdPoints
            })
          )(state.userData.result)
        },
        businessUserData: {
          ...state.businessUserData,
          result: fp.map(
            (userProfile) => ({
              ...userProfile,
              cpdPoints: action.payload.userQuiz === userProfile.user.id ? [] : userProfile.cpdPoints
            })
          )(state.businessUserData.result)
        },
        isRemovingUserQuiz: false
      })
    },
    failed: (state, action) => ({
      ...state,
      isRemovingUserQuiz: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/removeFailedUserQuiz.js